<template>
  <div>
    <v-container
      class="article-tips"
      pa-0
      v-for="(category, index) in items"
      :key="index"
    >
      <div v-if="category && category.articles && category.articles.length > 0">
        <a :class="'category-' + category.id" :id="category.name" />
        <v-layout align-center pr-6 mt-12 row v-if="showCategoryTitle">
          <v-flex text-xs>
            <h2 class="primary--text display-45">
              <span>{{ showCategoryName ? category.name : constants.extraArticles }}</span>
            </h2>
          </v-flex>
          <v-flex text-xs class="ml-8 mt-4 display-17">
            <nuxt-link :to="category.link" class="show-more-link d-flex">
              {{ constants.showAll }}
            </nuxt-link>
          </v-flex>
        </v-layout>
        <v-layout align-start column>
          <v-container pa-0>
            <v-layout align-start wrap>
              <v-flex
                v-for="(tip, index) in category.articles"
                :key="index"
                sm4
                xs12
              >
                <ArticleTip v-if="tip" :item="tip" :breakFooter="breakFooter" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-container pa-0>
          <v-layout>
            <v-flex xs12 v-if="index == 0 && Object.keys(items).length > 1">
              <SectionCompanies :hide-title="false" />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-container>
  </div>
</template>

<script>
import CategoryArticlesBaseVue from './mixins/CategoryArticlesBase.vue';
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  mixins: [CategoryArticlesBaseVue],
  data() {
    return {
      constants: t('titles.articles.lobby'),
    }
  }
};
</script>

<style scoped>
a.anchor {
  display: block;
  position: relative;
  top: -40px;
  visibility: hidden;
}

.show-more-link {
  justify-content: flex-end;
}
</style>
